"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultipleInputs = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _validators = _interopRequireWildcard(require("@jobmatchme/ui/es/utils/validators"));

var _ErrorText = _interopRequireDefault(require("@jobmatchme/ui/es/components/styleguide/ErrorText"));

var _PasswordField = _interopRequireDefault(require("@jobmatchme/ui/es/components/PasswordField"));

var _useOurTranslation = require("../../utils/useOurTranslation");

var _Button = _interopRequireDefault(require("@jobmatchme/ui/es/components/styleguide/Button"));

var _Optimizers = require("../../utils/Optimizers");

var _TextField = _interopRequireDefault(require("@jobmatchme/ui/es/components/TextField"));

var _Funnel = require("../Funnel");

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _reactHookForm = require("react-hook-form");

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _IntroText = _interopRequireDefault(require("../IntroText"));

var _Dialog = _interopRequireDefault(require("./Dialog"));

var _ProfileProvider = require("../../provider/ProfileProvider");

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * MultipleInputs component
 * @param {*} param0
 */
var MultipleInputsComponent = function MultipleInputsComponent(_ref) {
  var config = _ref.config,
      context = _ref.context;
  var t = (0, _useOurTranslation.useComponentTranslation)(config);

  var _useContext = (0, _react.useContext)(_ProfileProvider.ProfileActionsContext),
      setValue = _useContext.setValue;

  var discriminator = context && context.discriminator; // Phone validation code

  var TEL_OK = 0;
  var TEL_SHORT = 1;
  var TEL_LONG = 2;
  var TEL_ERROR = 3; // Here is a collection of icons of commonly used field types in forms.

  var iconPool = {
    email: require('@material-ui/icons/Mail').default,
    shield: require('@material-ui/icons/VerifiedUser').default,
    phone: require('@material-ui/icons/Phone').default,
    password: require('@material-ui/icons/Lock').default,
    text: require('@material-ui/icons/Create').default
  };

  var selectIcon = function selectIcon(icon) {
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '_';
    var Icon = iconPool[icon];
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(Icon, {}, 'icn' + iconPool[icon] + key);
  };

  var _useFunnelActions = (0, _Funnel.useFunnelActions)(),
      next = _useFunnelActions.next;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      inputsInvalid = _useState2[0],
      setInputsInvalid = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      nextStepIsAllowed = _useState4[0],
      setNextStepIsAllowed = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      loadingStart = _useState6[0],
      setLoadingStart = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      isDialogOpen = _useState8[0],
      setIsDialogOpen = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      showPassword = _useState10[0],
      setShowPassword = _useState10[1];

  var _useState11 = (0, _react.useState)(TEL_OK),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      telErrorCode = _useState12[0],
      setTelErrorCode = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 1),
      loadingEnd = _useState14[0]; // toggle password type


  var handleClickShowPassword = function handleClickShowPassword() {
    setShowPassword(!showPassword);
  };

  var _useForm = (0, _reactHookForm.useForm)({
    mode: 'onBlur'
  }),
      register = _useForm.register;

  var checkInvalid = (0, _react.useCallback)(function (fieldName) {
    return inputsInvalid.includes(fieldName);
  }, [inputsInvalid]);
  var activateSubmitIfFormIsValid = (0, _react.useCallback)(function () {
    var inputsValid = true;
    var values = ''; // Validate Form Fileds by Form Showing.
    // Data from saving context

    Object.entries(config.form).some(function (_ref2) {
      var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
          option = _ref3[0],
          field = _ref3[1];

      if (option !== 'button') {
        if (field.mandatory) {
          values = (context[config.valueName].value || {})[option];

          if (!(values && (0, _validators.default)(option)(values))) {
            inputsValid = false;
          }
        }
      }

      return false;
    }); // Validate Form Fileds after Form changes

    Object.entries(config.form).some(function (_ref4) {
      var _ref5 = (0, _slicedToArray2.default)(_ref4, 1),
          option = _ref5[0];

      values = checkInvalid(option);

      if (values) {
        inputsValid = false;
      }

      return false;
    }); // if the form data is correct, activate next button

    if (inputsValid) {
      setNextStepIsAllowed(true);
    }
  }, [checkInvalid, config.form, config.valueName, context]);
  (0, _react.useEffect)(function () {
    // Check Form Fields
    activateSubmitIfFormIsValid();
  }, [activateSubmitIfFormIsValid]);

  var handleForm = function handleForm(event, field, identifier) {
    var mandatory = field.mandatory;
    var fieldText = event.target.value;

    var validateInput = function validateInput(event, inputType) {
      var value = event.target.value;
      return inputType === 'phone' ? validatePhone(value) && value !== '' ? true : false : (0, _validators.default)(inputType)(value) && value !== '' ? true : false;
    };

    var handleChange = function handleChange(event, identifier) {
      var e = event || window.event;
      var eventValue = identifier === 'phone' ? (0, _validators.telNummerCleaning)(e.target.value) : e.target.value;
      setValue(config.valueName, {
        identifier: identifier,
        text: eventValue || undefined
      });
    };

    var isValid = mandatory ? validateInput(event, identifier) : fieldText.length > 0 ? validateInput(event, identifier) : true;

    if (isValid) {
      // erase field name from array with invalid fields if exists
      setInputsInvalid(inputsInvalid.filter(function (item) {
        return item !== identifier;
      }));
      handleChange(event, identifier);
    } else {
      // add fields names who are invalid
      setNextStepIsAllowed(false);

      if (!inputsInvalid.includes(identifier)) {
        setInputsInvalid(function (oldArrayState) {
          return [].concat((0, _toConsumableArray2.default)(oldArrayState), [identifier]);
        });
      }
    }
  };

  var validatePhone = function validatePhone(value) {
    var MIN_TEL_LENGTH = 7;
    var MAX_TEL_LENGTH = 20;

    var checkLength = function checkLength(tel) {
      if (tel.length < MIN_TEL_LENGTH) {
        return TEL_SHORT;
      } else if (tel.length > MAX_TEL_LENGTH) {
        return TEL_LONG;
      } else {
        return TEL_OK;
      }
    };

    var phoneValidationCode = (0, _validators.default)('phone')(value) ? TEL_OK : TEL_ERROR;
    var lenError = checkLength(value);
    var errorCode = lenError === TEL_OK ? phoneValidationCode : lenError;
    setTelErrorCode(errorCode);
    return errorCode > 0 ? false : true;
  };

  var phoneErrorHint = function phoneErrorHint(errorCode) {
    switch (errorCode) {
      case TEL_SHORT:
        return t(config.form.phone.min);

      case TEL_LONG:
        return t(config.form.phone.max);

      case TEL_ERROR:
        return t(config.form.phone.error);

      default:
        return '';
    }
  };

  var openDialog = function openDialog() {
    setIsDialogOpen(true);
  };

  var showErrorMessage = function showErrorMessage(identifier, field) {
    if ((field.type === 'text' || field.type === 'email' || field.type === 'password') && checkInvalid(identifier)) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorText.default, {
        text: t("".concat(field.error))
      });
    } else if (field.type === 'tel') {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorText.default, {
        text: phoneErrorHint(telErrorCode)
      });
    } else {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
    }
  };

  var selectComponent = function selectComponent(identifier, field, index) {
    var isFieldInvalid = checkInvalid(identifier);

    if (field.type === 'Button') {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        item: true,
        xs: 12,
        sm: field.width,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
          align: "center",
          id: 'btnBoxBcOnboarding',
          style: {
            marginTop: field.variant !== 'outlined' ? '2px' : '0px'
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
            flat: true,
            round: true,
            center: true,
            variant: field.variant ? field.variant : 'contained',
            texttransform: "none",
            id: 'btn' + field.action,
            color: field.color ? field.color : 'dark',
            className: "".concat(_styleModule.default.funnelbutton, " ").concat(field.color === 'dark' ? _styleModule.default.btnBorder : ''),
            disabled: field.mandatory && !nextStepIsAllowed,
            loading: field.action === 'next' && {
              start: loadingStart,
              end: loadingEnd,
              animate: true
            },
            onClick: function onClick() {
              field.action === 'next' && setLoadingStart(true);
              field.action === 'next' ? next() : openDialog();
            },
            children: t(field.translation)
          })
        })
      }, field.type);
    } else if (field.type === 'ModalDialog') {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dialog.default, {
        field: field,
        isDialogOpen: isDialogOpen,
        setIsDialogOpen: setIsDialogOpen,
        discriminator: discriminator,
        t: t
      });
    } else {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        item: true,
        xs: 12,
        children: identifier !== 'password' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, {
          fullWidth: true,
          bsSize: "lg",
          defaultInput: true,
          type: field.type,
          name: identifier,
          customSize: "medium",
          error: isFieldInvalid,
          id: "".concat(identifier, "-tf-").concat(index),
          placeholder: t(field.translation),
          defaultValue: (context[config.valueName].value || {})[identifier],
          onChange: function onChange(e) {
            return handleForm(e, field, identifier);
          },
          onBlur: function onBlur(e) {
            return handleForm(e, field, identifier);
          },
          startAdornment: selectIcon(identifier),
          inputProps: {
            tabIndex: index + 1
          },
          touched: true
        }, "".concat(identifier, "-inpt-").concat(index)) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_PasswordField.default, {
          inline: true,
          filledIcon: true,
          name: identifier,
          togglePassword: showPassword,
          placeholder: t(field.translation),
          onClick: handleClickShowPassword,
          onChange: function onChange(e) {
            return handleForm(e, field, identifier);
          },
          onBlur: function onBlur(e) {
            return handleForm(e, field, identifier);
          },
          inputProps: register(identifier, {
            required: true,
            tabIndex: index + 1
          }),
          touched: true
        })
      }, field.type);
    }
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
    className: _styleModule.default.MultipleInputs,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IntroText.default, {
      headline: t(config.translations.text),
      text: config.translations.hint ? t(config.translations.hint) : ''
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
      container: true,
      direction: "col",
      justifyContent: "center",
      alignItems: "center",
      alignContent: "center",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        item: true,
        xs: 12,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
          className: _styleModule.default.fields,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
            container: true,
            spacing: 4,
            children: Object.entries(config.form).map(function (_ref6, index) {
              var _ref7 = (0, _slicedToArray2.default)(_ref6, 2),
                  option = _ref7[0],
                  thisItem = _ref7[1];

              return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
                children: [selectComponent(option, thisItem, index), showErrorMessage(option, thisItem)]
              });
            })
          })
        })
      }), config.help && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        item: true,
        xs: 12,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
          container: true,
          direction: "col",
          justifyContent: "center",
          alignItems: "left",
          alignContent: "left",
          className: _styleModule.default.information,
          children: Object.entries(config.help).map(function (_ref8) {
            var _ref9 = (0, _slicedToArray2.default)(_ref8, 2),
                item = _ref9[0],
                translation = _ref9[1];

            return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
                item: true,
                xs: 1,
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
                  children: selectIcon('shield', item)
                })
              }, item), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
                item: true,
                xs: 11,
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                  children: t(translation)
                })
              }, item + 'info')]
            });
          })
        })
      })]
    })]
  });
};

var MultipleInputsWrapper = (0, _Optimizers.memoizeComponentByValue)(MultipleInputsComponent);

var MultipleInputs = function MultipleInputs(_ref10) {
  var config = _ref10.config;
  var context = (0, _react.useContext)(_ProfileProvider.ProfileContext);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(MultipleInputsWrapper, {
    config: config,
    context: context
  });
};

exports.MultipleInputs = MultipleInputs;